<template>
  <v-container fluid>
    <v-row>
      <v-col>
        <v-card>
          <v-toolbar :dark="$vuetify.theme.dark" color="primary">
            <v-toolbar-title class="textwithbackground--text">
              {{ title }}
            </v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <general-error v-if="!!generalError" />
            <v-progress-linear :active="isLoading" color="loader" indeterminate />
            <organization-info-view :organization-info="request">
              <template v-slot:additional>
                <v-expansion-panel v-test="{ panel: '' }">
                  <v-expansion-panel-header>
                    <div id="attach_file">
                      <v-icon>
                        attach_file
                      </v-icon>
                      {{ $t('Прикрепленные документы') }}
                    </div>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content eager>
                    <identity-document-list-view
                        :request-files="requestFiles"
                        :document-types="requiredDocumentTypes"
                        :loading="isLoading" />
                  </v-expansion-panel-content>
                </v-expansion-panel>

              </template>
            </organization-info-view>
            <v-row>
              <v-col class="mt-3">
                <ValidationObserver ref="processComment">
                  <validatable-textarea
                      v-if="inprocess || request.processComment"
                      v-model="processComment"
                      :readonly="!inprocess"
                      :label="$t('Комментарий')"
                      :rules="{ required: rejected && inprocess }" />
                </ValidationObserver>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-row>
              <v-col class="text-left">
                <btn-icon-tip
                    :btn-color="$vuetify.breakpoint.smAndUp
                      ? 'primary'
                      : ''"
                    :icon-color="$vuetify.breakpoint.xsOnly
                      ? 'primary'
                      : ''"
                    :icon="$vuetify.breakpoint.xsOnly
                      ? 'reply'
                      : ''"
                    :tip="$t('К списку запросов')"
                    @click="goToRoute(`${urlRootPath}/organizationRegistrationRequests/${request.status}`)" />
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import BtnIconTip from '@/components/reused/ui/BtnIconTip.vue'
  import ValidatableTextarea from '@/components/reused/ui/ValidatableTextarea.vue'
  import OrganizationInfoView from '@/components/reused/organization/OrganizationInfoView.vue'
  import IdentityDocumentListView from '@/components/reused/files/IdentityDocumentListView.vue'
  import GeneralError from '@/components/reused/common/GeneralError.vue'
  import { ORG_REQUEST_STATUSES } from '@/constants/business'
  import organizationMixin from '@/utils/mixins/scoped/organizationMixin.js'
  import { mapActions, mapState } from 'vuex'
  import { ORGANIZATION_REQUESTS, IDENTITY_FILES } from '@/constants/store.js'

  export default {
    components: {
      BtnIconTip,
      OrganizationInfoView,
      IdentityDocumentListView,
      GeneralError,
      ValidatableTextarea
    },
    mixins: [organizationMixin],
    props: {
      organizationId: {
        type: String,
        required: true
      }
    },
    data () {
      return {
        isLoading: false,
        processComment: null,
        rejected: false
      }
    },
    computed: {
      ...mapState(ORGANIZATION_REQUESTS.NAMESPACE, {
        request: state => (state[ORGANIZATION_REQUESTS.STATE.CURRENT_REQUEST] || {})
      }),
      ...mapState(IDENTITY_FILES.NAMESPACE, {
        requiredDocumentTypes: state => (state[IDENTITY_FILES.STATE.REQUIRED_DOCUMENT_TYPES] || [])
      }),
      title () {
        return this.$t(this.inprocess
          ? 'Обработка запроса на регистрацию организации'
          : 'Просмотр запроса на регистрацию организации')
      },
      requestType () {
        return this.getRequestTypeByOrganization(
          this.request.organizationType,
          this.request.participantType,
          this.request.isEIO)
      },
      inprocess () {
        return this.isAdmin &&
          this.request.status === ORG_REQUEST_STATUSES.INPROCESS
      },
      requestFiles () {
        return this.request.documents || []
      }
    },
    created () {
      const vm = this
      vm.clearStore().then(() => {
        vm.getOrganizationRequestInfo()
      })
    },
    beforeDestroy () {
      this.clearStore()
    },
    methods: {
      ...mapActions(ORGANIZATION_REQUESTS.NAMESPACE, {
        getOrganizationRequestInfoAction: ORGANIZATION_REQUESTS.ACTIONS.GET_ORGANIZATION_REQUEST_INFO,
        // processOrganizationRegistrationRequestAction: ORGANIZATION_REQUESTS.ACTIONS.PROCESS_ORGANIZATION_REGISTRATION_REQUEST,
        clearOrganizationRequestInfoAction: ORGANIZATION_REQUESTS.ACTIONS.CLEAR_ORGANIZATION_REQUEST_INFO
      }),
      ...mapActions(IDENTITY_FILES.NAMESPACE, {
        getRequiredDocumentTypesAction: IDENTITY_FILES.ACTIONS.GET_REQUIRED_DOCUMENT_TYPES,
        clearRequiredDocumentTypesAction: IDENTITY_FILES.ACTIONS.CLEAR_REQUIRED_DOCUMENT_TYPES
      }),
      clearStore: async function () {
        await Promise.all(
          [
            this.clearOrganizationRequestInfoAction(),
            this.clearRequiredDocumentTypesAction()
          ])
      },
      getOrganizationRequestInfo: async function () {
        try {
          this.isLoading = true
          await this.getOrganizationRequestInfoAction({
            organizationId: this.organizationId
          })
          this.processComment = this.request.processComment || null
          await this.getRequiredDocumentTypesAction({
            requestType: this.requestType
          })
          this.isLoading = false
        } catch (error) {
          this.isLoading = false
          this.throwIfNotServerError(error)
        }
      },
      approve: function () {
        const vm = this
        vm.rejected = false
        // nextTick: действия после перерисовки разметки (проверка полей)

        vm.$nextTick(() => {
          vm.processOrganizationRegistrationRequest()
        })
      },
      reject: function () {
        const vm = this
        vm.rejected = true
        vm.$nextTick(() => {
          vm.processOrganizationRegistrationRequest()
        })
      }
      // processOrganizationRegistrationRequest: async function () {
      //   const result = await this.$refs.processComment.validate()
      //   if (!result) {
      //     return
      //   }
      //   try {
      //     this.isLoading = true
      //     await this.processOrganizationRegistrationRequestAction({
      //       organizationId: this.organizationId,
      //       model: {
      //         processComment: this.processComment,
      //         status: this.rejected
      //           ? REQUEST_STATUSES.REJECTED
      //           : REQUEST_STATUSES.APPROVED
      //       }
      //     })
      //     this.isLoading = false
      //     this.goToRoute(`${this.urlRootPath}/organizationRegistrationRequests/${this.request.status}`)
      //   } catch (error) {
      //     this.isLoading = false
      //     this.throwIfNotServerError(error)
      //   }
      // }
    }
  }
</script>
